<section class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1">Invita-ti prietenii</h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="col-md-8 mb-3 mb-md-0">

      <!-- Event invitations -->
      <section class="card border-0 mb-4">

        <div class="card-body">
          <ul class="nav nav-tabs nav-justified flex-nowrap mb-0" role="tablist">
            <li class="nav-item" role="presentation">
              <button (click)="onTabSelected(tabs.INVITED)" [ngClass]="{'active' : selectedTab === tabs.INVITED}"
                class="nav-link rounded-pill" type="button" role="tab">
                <i class="ai-open-book me-2 me-sm-3"></i>Invitati</button>
            </li>
            <li class="nav-item" role="presentation">
              <button (click)="onTabSelected(tabs.IMPORT)" [ngClass]="{'active' : selectedTab === tabs.IMPORT}"
                class="nav-link rounded-pill" type="button" role="tab">
                <i class="ai-cloud-upload me-2 me-sm-3"></i>Importa</button>
            </li>
          </ul>

          <div class="tab-content">
            <!-- Invited -->
            <div [ngClass]="{'show active': selectedTab === tabs.INVITED}" class="tab-pane fade" role="tabpanel">
              <form [formGroup]="formFilter" novalidate autocomplete="off">
                <div class="row gy-2 mt-4 mb-3">
                  <div class="col-sm-8">
                    <div class="position-relative">
                      <i class="ai-search fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
                      <input formControlName="keyword" class="form-control form-control-sm ps-5" type="search"
                        placeholder="Cauta...">
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <select formControlName="status" class="form-select form-select-sm">
                      <option value="all">Toate</option>
                      <option value="unsent">Netrimise</option>
                      <option value="sent">Trimise</option>
                      <option value="contributed">Au contribuit</option>
                      <option value="not-contributed">Nu au contribuit</option>
                    </select>
                  </div>
                </div>
              </form>

              <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
                <!-- Add new contact-->
                <div class="col">
                  <div
                    class="card h-100 justify-content-center align-items-center border-dashed rounded-5 py-5 px-3 px-sm-4">
                    <a (click)="onAddContactClick(editContactModalTemplate)"
                      class="stretched-link d-flex align-items-center fw-semibold text-decoration-none" role="button"><i
                        class="ai-circle-plus fs-xl me-2"></i>Adauga un contact</a>
                  </div>
                </div>

                <div *ngFor="let contact of filteredContacts | slice: (page - 1) * itemsPerPage : page * itemsPerPage"
                  class="col">
                  <div class="card bg-gray h-100 border-0">
                    <div class="card-body">
                      <div class="d-flex flex-column align-items-center text-center">
                        <!-- <div class="bg-light flex-shrink-0 rounded-circle" style="padding: 3px;"> -->
                        <gs-avatar [name]="contact.name" [email]="contact.email" [size]="64"
                          ngbTooltip="{{contact.name}}" class="mb-3"></gs-avatar>
                        <!-- </div> -->
                        <h6 class="mb-0">{{contact.name}}</h6>
                        <div class="ps-3 text-left mw-100">
                          <p ngbTooltip="{{contact.email}}" class="fs-sm text-muted mb-0 text-truncate"><i
                              class="ai-mail me-2"></i>{{contact.email}}</p>
                          <p *ngIf="contact.invitedDate" class="fs-sm text-success mb-0"><i class="ai-time me-2"></i>{{
                            contact.invitedDate | dfnsFormatDistanceToNowStrictPure:{addSuffix: true} }}</p>
                          <p *ngIf="!contact.invitedDate" class="fs-sm text-muted mb-0"><i
                              class="ai-time me-2"></i>Netrimisa</p>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer d-flex align-items-center justify-content-between px-0 pb-4 pt-0 border-0">
                      <button (click)="onEditClick(contact, editContactModalTemplate)" ngbTooltip="Modifica"
                        class="btn btn-link btn-sm text-dark fs-sm fw-semibold" type="button"><i
                          class="ai-edit fs-xl"></i></button>

                      <button (click)="onDeleteClick(contact)" ngbTooltip="Sterge"
                        class="btn btn-link btn-sm text-danger fs-sm fw-semibold" type="button"><i
                          class="ai-trash fs-xl"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pagination-->
              <div class="d-sm-flex align-items-center pt-4 pt-sm-5">
                <nav class="order-sm-2 ms-sm-auto mb-4 mb-sm-0" aria-label="Orders pagination">
                  <ngb-pagination [(page)]="page" [collectionSize]="filteredContacts.length" [pageSize]="itemsPerPage"
                    [maxSize]="5" [directionLinks]="false" [boundaryLinks]="false" [rotate]="true" size="sm"
                    (pageChange)="onPageChanged()" class="d-flex justify-content-center"></ngb-pagination>
                </nav>
              </div>

              <div class="d-flex flex-column flex-sm-row justify-content-between mt-4">
                <a [routerLink]="['/eveniment', eventCode]" class="btn btn-secondary btn-lg mb-3 mb-sm-0"
                  type="button">Inapoi</a>
                <div ngbDropdown class="dropdown">
                  <button ngbDropdownToggle type="button" class="btn btn-primary btn-lg dropdown-toggle">
                    Trimite
                  </button>
                  <ul ngbDropdownMenu class="dropdown-menu my-1">
                    <li><a ngbDropdownItem (click)="onSendInvitesClick()" class="dropdown-item" role="button">Trimite
                        invitatii</a></li>
                    <li><a ngbDropdownItem (click)="onSendInvitesClick(true)" class="dropdown-item"
                        role="button">Retrimite
                        invitatii</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Import -->
            <div [ngClass]="{'show active': selectedTab === tabs.IMPORT}" class="tab-pane fade" role="tabpanel">

              <div class="steps steps-horizontal steps-center mt-2 mb-4">
                <div class="step" [ngClass]="{'active': selectedStep === steps.FILE}">
                  <div class="step-number" ngbTooltip="Selecteaza sursa import">
                    <div class="step-number-inner fs-4">
                      <i class="ai-file"></i>
                    </div>
                  </div>
                  <div class="step-body">
                    <h5 class="pb-1 mb-2" [ngClass]="{'text-primary': selectedStep === steps.FILE}">Selecteaza sursa
                    </h5>
                  </div>
                </div>

                <div class="step" [ngClass]="{'active': selectedStep === steps.MAPPING}">
                  <div class="step-number" ngbTooltip="Selecteaza coloane">
                    <div class="step-number-inner fs-4">
                      <i class="ai-layout-column"></i>
                    </div>
                  </div>
                  <div class="step-body">
                    <h5 class="pb-1 mb-2" [ngClass]="{'text-primary': selectedStep === steps.MAPPING}">Selecteaza
                      coloane</h5>
                  </div>
                </div>

                <div class="step" [ngClass]="{'active': selectedStep === steps.CONTACTS}">
                  <div class="step-number" ngbTooltip="Selecteaza contacte">
                    <div class="step-number-inner fs-4">
                      <i class="ai-user-group"></i>
                    </div>
                  </div>
                  <div class="step-body">
                    <h5 class="pb-1 mb-2" [ngClass]="{'text-primary': selectedStep === steps.CONTACTS}">Selecteaza
                      contacte</h5>
                  </div>
                </div>
              </div>

              <div *ngIf="selectedStep === steps.FILE">

                <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mt-4">

                  <div *ngIf="scriptsLoaded" class="col">
                    <div class="card bg-gray border-0">
                      <div class="card-body">
                        <div class="d-flex flex-column align-items-center text-center">
                          <label class="btn btn-outline-dark btn-icon btn-lg rounded-circle btn-input">
                            <i class="ai-file"></i>
                            <input #fileImportInput (change)="csvFileChangeListener($event)" type="file" accept=".csv">
                          </label>
                          <h5 class="mt-2">Fisier CSV</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="scriptsLoaded" class="col">
                    <div class="card bg-gray border-0">
                      <div class="card-body">
                        <div class="d-flex flex-column align-items-center text-center">
                          <label class="btn btn-outline-dark btn-icon btn-lg rounded-circle btn-input">
                            <i class="ai-file-text"></i>
                            <input #fileImportInputExcel (change)="excelFileChangeListener($event)" type="file"
                              accept=".xls,.xlsx">
                          </label>
                          <h5 class="mt-2">Fisier Excel</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="card bg-gray border-0">
                      <div class="card-body">
                        <div class="d-flex flex-column align-items-center text-center">
                          <a (click)="onFacebookInviteFriendsClick()"
                            class="btn btn-outline-dark btn-icon btn-lg btn-facebook rounded-circle">
                            <i class="ai-facebook"></i>
                          </a>
                          <h5 class="mt-2">Facebook</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="card bg-gray border-0">
                      <div class="card-body">
                        <div class="d-flex flex-column align-items-center text-center">
                          <a (click)="onImportGoogleContactsClick()"
                            class="btn btn-outline-dark btn-icon btn-lg btn-google rounded-circle">
                            <i class="ai-google"></i>
                          </a>
                          <h5 class="mt-2">Google</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="card bg-gray border-0">
                      <div class="card-body">
                        <div class="d-flex flex-column align-items-center text-center">
                          <a (click)="onImportOutlookContactsClick()"
                            class="btn btn-outline-dark btn-icon btn-lg btn-microsoft rounded-circle">
                            <i class="ai-twitter"></i>
                          </a>
                          <h5 class="mt-2">Microsoft</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="selectedStep === steps.MAPPING">
                <form [formGroup]="formMapping" novalidate autocomplete="off" class="w-75 mx-auto mt-3 mb-5">
                  <div class="row mb-4">
                    <div class="col-12">
                      <div class="alert alert-info d-flex mb-0" role="alert">
                        <i class="ai-circle-info fs-xl pe-1 me-2"></i>
                        <div>Selecteaza coloanele corespunzatoare datelor necesare procesului de invitare. Daca
                          folosesti sabloanele predefinite in format <a class="alert-link"
                            href="/assets/content/contacts-sample.xlsx" target="_blank">EXCEL</a> si <a
                            class="alert-link" href="/assets/content/contacts-sample.csv" target="_blank">CSV</a>,
                          specificarea se va face automat.</div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <label class="col-sm-2 col-form-label col-form-label-lg" for="columnName">Nume</label>
                    <div class="col-sm-10">
                      <select formControlName="columnName"
                        [ngClass]="{'is-invalid': vs.hasErrors(formMapping, 'columnName')}"
                        class="form-select form-select-lg" id="columnName">
                        <option *ngFor="let header of headers" [ngValue]="header.value">{{header.name}}</option>
                      </select>
                      <div class="invalid-feedback" *ngIf="vs.hasErrors(formMapping, 'columnName')">
                        {{vs.getError(formMapping,
                        'columnName')}}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <label class="col-sm-2 col-form-label col-form-label-lg" for="columnEmail">Email</label>
                    <div class="col-sm-10">
                      <select formControlName="columnEmail"
                        [ngClass]="{'is-invalid': vs.hasErrors(formMapping, 'columnEmail')}"
                        class="form-select form-select-lg" id="columnEmail">
                        <option *ngFor="let header of headers" [ngValue]="header.value">{{header.name}}</option>
                      </select>
                      <div class="invalid-feedback" *ngIf="vs.hasErrors(formMapping, 'columnEmail')">
                        {{vs.getError(formMapping,
                        'columnEmail')}}
                      </div>
                    </div>
                  </div>

                </form>
              </div>

              <div *ngIf="selectedStep === steps.CONTACTS" class="mx-5">
                <ngx-datatable #contactsTable class="bootstrap" [rows]="importedContacts"
                  [columns]="[{ prop: 'name' }, { prop: 'email' }]" [columnMode]="ColumnMode.force"
                  [reorderable]="false" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="10"
                  [sortType]="SortType.single" [selectionType]="SelectionType.checkbox" [selectAllRowsOnPage]="false"
                  [selected]="selectedContacts" [loadingIndicator]="true" (select)="onSelect($event)">

                  <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                    [resizeable]="false" [headerCheckboxable]="true" [checkboxable]="true">
                  </ngx-datatable-column>

                  <ngx-datatable-column prop="name">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <span class="fw-bold">{{value}}</span>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column prop="email">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <span>{{value}}</span>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-footer>
                    <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                      let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset"
                      let-isVisible="isVisible">
                      <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'d-none'"
                        [pagerNextIcon]="'d-none'" [page]="curPage" [size]="pageSize" [count]="rowCount"
                        [hidden]="!((rowCount / pageSize) > 1)" (change)="contactsTable.onFooterPage($event)">
                      </datatable-pager>
                    </ng-template>
                  </ngx-datatable-footer>
                </ngx-datatable>
              </div>

              <div *ngIf="selectedStep !== steps.FILE"
                class="d-flex flex-column flex-sm-row justify-content-between mt-4">
                <button (click)="onBackClick()" class="btn btn-secondary btn-lg mb-3 mb-sm-0"
                  type="button">{{backLabel}}</button>
                <button (click)="onNextClick()" class="btn btn-primary btn-lg" type="button">{{nextLabel}}</button>
              </div>

            </div>

          </div>

        </div>
      </section>

    </div>

    <!-- Side FAQ-->
    <div class="col-md-4">

      <div class="card border-0 mb-4">
        <div class="card-body">
          <h4 class="card-title"><i class="ai-bulb text-primary lead pe-1 me-2"></i>Informatii suplimentare</h4>
          <div ngbAccordion [closeOthers]="true">
            <div ngbAccordionItem [collapsed]="false">
              <div ngbAccordionHeader>
                <button ngbAccordionButton>
                  Despre invitatii
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody class="fs-sm">
                  <ng-template>
                    Invita-ti familia si prietenii sa contribuie la cadoul tau sau sa
                    sustina financiar cauza pe
                    care tu o promovezi.
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader>
                <button ngbAccordionButton>
                  Despre import
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody class="fs-sm">
                  <ng-template>
                    Tot ce trebuie sa faci este sa le introduci adresele de email iar noi
                    le vom trimite un mesaj
                    cu toate informatiile despre evenimentul tau, despre cum pot trimite "cadoul" online, rapid
                    si sigur, prin plata securizata cu cardul. Poti folosi aceste sabloane in format <a
                      href="/assets/content/contacts-sample.xlsx" target="_blank">EXCEL</a> si <a
                      href="/assets/content/contacts-sample.csv" target="_blank">CSV</a>.
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader>
                <button ngbAccordionButton>
                  Despre promovare
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody class="fs-sm">
                  <ng-template>
                    In plus, le poti trimite linkul catre evenimentul tau prin orice canal
                    de comunicare ai la dispozitie
                    (email, Facebook, Twitter, WhatsApp, Messenger, etc).
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</section>


<!-- Edit invitation -->
<ng-template #editContactModalTemplate let-modal>
  <div class="modal-header border-0">
    <h4 class="modal-title">{{editedItem ? 'Modifica' : 'Adauga'}} contact</h4>
    <button (click)="modal?.dismiss()" class="btn-close" type="button" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onContactSubmit()" class="pt-0" novalidate autocomplete="off">
    <div class="modal-body">
      <div class="row row-cols-1 g-4">
        <div class="col">
          <label class="form-label" for="name">Nume</label>
          <input formControlName="name" [ngClass]="{'is-invalid': vs.hasErrors(form, 'name')}" class="form-control"
            type="text" placeholder="" id="name">
          <div *ngIf="vs.hasErrors(form, 'name')" class="invalid-feedback">{{vs.getError(form, 'name')}}
          </div>
        </div>

        <div class="col">
          <label class="form-label" for="email">Email</label>
          <input formControlName="email" [ngClass]="{'is-invalid': vs.hasErrors(form, 'email')}" class="form-control"
            type="email" placeholder="" id="email">
          <div *ngIf="vs.hasErrors(form, 'email')" class="invalid-feedback">{{vs.getError(form, 'email')}}
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer border-0">
      <button (click)="modal?.close()" class="btn btn-secondary w-100 w-sm-auto mb-3 mb-sm-0"
        type="button">Anuleaza</button>
      <button class="btn btn-primary w-100 w-sm-auto ms-sm-3" type="submit">Salveaza</button>
    </div>
  </form>
</ng-template>
